import { Link as RouterLink } from 'src/components/link';

import { NavItemProps } from './types';

// ----------------------------------------------------------------------

type Args = Pick<NavItemProps, 'path' | 'active' | 'disabled' | 'hasChild' | 'externalLink'>;

export function navLinkProps({ path, active, disabled, hasChild, externalLink }: Args) {
  if (hasChild || disabled) return {};

  if (externalLink) return { href: path, target: '_blank', rel: 'noopener' };

  return {
    component: RouterLink,
    to: path,
    'aria-current': active ? ('page' as const) : undefined,
  };
}
